import "./sentry"; // muss vor allen App-Imports stehen
import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import { BrandingProvider } from "./branding/BrandingContext";
import "./i18n";

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

// Sentry-ErrorBoundary umschliesst unsere bestehende ErrorBoundary,
// damit React-Render-Fehler automatisch gemeldet werden.
root.render(
  <Sentry.ErrorBoundary fallback={null}>
    <ErrorBoundary>
      <BrandingProvider>
        <App />
      </BrandingProvider>
    </ErrorBoundary>
  </Sentry.ErrorBoundary>
);
// Region: europe-west10
